const extractCustomsDisclosureCertificate = require('./negotiateCustomsEventText/extractCustomsDisclosureCertificate');
const extractCustomsReceipt = require('./negotiateCustomsEventText/extractCustomsReceipt');
const { getTranslationDictionary } = require('core');

function negotiateCustomsEventText(text = '') {
	const translationDictionary = getTranslationDictionary();

	if(ifTextStartsWith('tk'))
		return extractCustomsReceipt(text);

	else if(ifTextStartsWith('ua'))
		return extractCustomsDisclosureCertificate(text);

	else if(ifTextStartsWith('error'))
		return translationDictionary['customsError'];

	return translationDictionary['customsMessage'];

	function ifTextStartsWith(query) {
		return text.toLowerCase().startsWith(query);
	}
}

module.exports = negotiateCustomsEventText;